import type { FormInputType } from '@/components/UI/Form/types'

import { NPS_RATINGS } from '../sessionFeedback'

export default function getSeriesFeedbackTutorFormInputs(seriesTitle: string): FormInputType[] {
  const npsFormInput: FormInputType = {
    name: 'tutor_nps_rating',
    type: 'select-tab',
    label: `Thanks for hosting "${seriesTitle}"! How likely would you be to recommend tutoring this program to a friend, on a scale from 0 (not likely) to 10 (very likely)?`,
    options: NPS_RATINGS.map(item => ({
      value: `${item}`,
      label: item,
    })),
    required: true,
    size: 6,
  }

  return [
    npsFormInput,
    {
      label: 'Tell us more! Why did you select the rating above? (optional)',
      type: 'text',
      name: 'comment',
      required: false,
      size: 6,
    },
  ]
}
